import { useEffect } from 'react';

import { persistProjectReferralAttribution } from '@/utils/referral-attribution';

/**
 * When the project URL includes ?referralCode=, set legacy attribution cookies
 * so auth/signup flows can attribute the referee after redirects.
 */
export function usePersistProjectReferralFromSearch(
  projectId: string,
  search: { referralCode?: string } | undefined,
): void {
  useEffect(() => {
    const code = search?.referralCode?.trim();
    if (code) {
      persistProjectReferralAttribution({
        referralCode: code,
        projectId,
      });
    }
  }, [search?.referralCode, projectId]);
}
